<template>
    <div id="power-data" class="row-center" v-if="reFresh">
        <div class="p-title">
            <span :class="{active:uid === 'Complex'}" @click="checkreport('Complex')">综合能耗</span>
            <span :class="{active:uid === 'Suboption'}" @click="checkreport('Suboption')">分项能耗</span>
            <span :class="{active:uid === 'PowerTime'}" @click="checkreport('PowerTime')">能耗同环比</span>
            <span :class="{active:uid === 'Range'}" @click="checkreport('Range')">计划与实际能耗</span>
        </div>
        <div class="p-cont">
            <div class="left column-center">
                <div class="list">
                    <div class="search">
                        <input type="text" v-model="filterText" placeholder="请输入关键字" />
                        <img src="../../assets/img/search.png" alt="" />
                    </div>
                    <div class="tree" id="index-tree"  >
                        <el-scrollbar style="height:100%">
                            <el-tree
                                :props="defaultProps"
                                :expand-on-click-node="false"
                                check-strictly
                                check-on-click-node
                                default-expand-all
                                @check="currentChange"
                                show-checkbox
                                node-key="id"
                                @node-click="nodeClick"
                                ref="tree"
                                :data="treeData"
                                :filter-node-method="filterNode"
                                :default-checked-keys="defaultchecked"
                            >
                                <span
                                slot-scope="{ node, data }"
                                class="power-data-item"
                                >
                                <span
                                    :class="[
                                    'power-data-item-label',
                                    { checked: data.id === currentLoop.id },
                                    ]"
                                >
                                    <span slot="reference"> {{ data.name }}</span>
                                </span>
                                </span>
                            </el-tree>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
            <div class="data">
                <div v-if="treeData.length === 0" class="no-found-data-warpper">
                    <img :src="require('../../assets/img/not_found_data.png')" alt="" />
                </div>
                <component v-else-if="currentLoop" :selectedLoops="checkedLoops" :currentLoop="currentLoop"
                    :is="componentName" />
            </div>
        </div>
    </div>
</template>
<script>
import reportDataBase from "./reportDataBase.vue";
    import {
        harmonicAnalysis,
        InverterArea,
        treeBuilding
    } from "../../api/power";

    export default {
        name: "PowerDataHome",
        components: {
            reportDataBase
        },
        data() {
            return {
                selectedNodes: [],
                reFresh: true,
                checkedLoops: [],
                currentLoop: null,
                filterText: "",
                loops: [],
                defaultchecked:null,
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                treeData:[]
            };
        },
        computed: {
            tag() {
                return this.$route.params.tag;
            },
            routeName() {
                return this.$route.params.name;
            },
            uid(){
               return  this.$route.query.uid
            },
            componentName() {
                switch (this.$route.query.uid) {
                    case "PowerTime":
                    case "Range":
                    case "Suboption":
                    case "Complex":
                        return "reportDataBase";
                }
            },
            // treeData() {
            //     let self = this
            //     // switch (self.$route.params.tag) {
            //         // case "EnergyReportForm":
            //             if(this.loops.length>0){
            //                 this.defaultchecked = []
            //                 this.checkedLoops = []
            //                 let list = []
            //                 this.loops.forEach((item,index)=>{
            //                         self.defaultchecked.push(item.id)
            //                         self.checkedLoops.push(item)
            //                         if(item.children){
            //                             item.children.forEach((elm,inx)=>{
            //                                     self.defaultchecked.push(elm.id)
            //                                     self.checkedLoops.push(elm)
            //                             })
            //                         }
            //                         // list.push(item)
            //                 })
            //                 // this.defaultchecked = [this.loops[0].id,this.loops[0].id,this.loops[0].id]
            //                 // self.checkedLoops = [this.loops[0],this.loops[0].children[0],this.loops[0].children[1]]
            //                 self.currentLoop = this.loops[0]
            //             }
            //             return self.loops
            //         // break
            //     // }
            // },
        },
        mounted() {
            this.GetreeBuilding();
        },
        methods: {
            checkreport(name){
                this.$router.replace({ name: 'HomePageOverview', query: { uid: name } })
            },
            //楼栋
            GetreeBuilding(){
                let self = this
                treeBuilding().then((res) => {
                    if(this.$store.getters.projectId==1||this.$store.getters.projectId==4){
                        this.loops = res.data.data.tree.map(e=>{e.children = []; return e})
                        this.loops[0].name = this.$store.getters.selProjectInfo.projectName
                    }else{
                        this.loops = res.data.data.tree;
                    }
                    
                    if(this.loops.length>0){
                        this.defaultchecked = []
                        this.checkedLoops = []
                        let list = []
                        this.loops.forEach((item,index)=>{
                                self.defaultchecked.push(item.id)
                                self.checkedLoops.push(item)
                                if(item.children){
                                    item.children.forEach((elm,inx)=>{
                                            self.defaultchecked.push(elm.id)
                                            self.checkedLoops.push(elm)
                                    })
                                }
                                // list.push(item)
                        })
                        // this.defaultchecked = [this.loops[0].id,this.loops[0].id,this.loops[0].id]
                        // self.checkedLoops = [this.loops[0],this.loops[0].children[0],this.loops[0].children[1]]
                        self.currentLoop = this.loops[0]
                    }
                    self.treeData = self.loops
                });
            },
            currentChange(data, node, n) {
                this.selectedNodes = node.checkedNodes;
                this.checkedLoops = this.selectedNodes.filter((l) => {
                    return l ? l.name.indexOf(this.filterText) !== -1 : false;
                });
            },
            //点击传参
            //侧边栏子回路点击之后传参
            nodeClick(data) {
                this.currentLoop = data;
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            },
        },
        watch: {
            tag() {
                this.reFresh = false;
                this.$nextTick(() => {
                    this.reFresh = true;
                });
                this.selectedNodes = [];
                this.filterText = ""
                this.checkedLoops = [];
                this.$refs.tree.setCheckedNodes([]);
            },
            filterText(val) {
                this.$refs.tree.filter(val);
                this.checkedLoops = this.selectedNodes.filter((l) => {
                    return l.name.indexOf(val) !== -1;
                });
            },
        },
    };
</script>

<style scoped lang="less">


    .clearsel{
        height:45rem;
        // line-height: 45rem;
        border-top: 1px solid rgba(0, 0, 0, 0.15);
        width: 100%;
        text-align: center;
        font-size: 18rem;
        cursor: pointer;
        padding: 10rem 0;
        span{
            display: inline-block;
            width: 50%;
        }
    }
    #power-data {
        width: 100%;
        height: 100%;
        // background: #ffffff;
        .p-title{
            font-size: 18rem;
            font-weight: bold;
            height: 50rem;
            line-height: 50rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            // padding: 0 20rem;
            width: 100%;
            background: #ffffff;
            span {
                display: inline-block;
                font-size: 16rem;
                font-weight: bold;
                border-top: 2px solid transparent;
                margin: 0 20rem;
                line-height: 50rem;
                cursor: pointer;
            }
            .active {
                border-top: 2px solid #0d94ff;
                color: #0d94ff;
            }
        }
        .p-cont{
            height: calc(100% - 50rem);
            width: 100%;
            justify-content: space-between;
            display: flex;
        }
        .data {
            position: relative;
            .w(860);
            height: 100%;
            background: #ffffff;
            flex: 1;
            
        }

        .left {
            height: 100%;
            justify-content: flex-start !important;
            background-color: #fff;
            .w(325);
            border-right: 1px solid rgba(0, 0, 0, 0.15);
            .list {
                padding: 20rem 0rem 24rem 24rem;
                overflow: hidden;
                width: 100%;
                .active-title{
                    font-size: 18rem;
                    font-weight: 500;
                    margin-bottom: 20rem;
                }
                .search {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    height: 37px;
                    margin-right: 20rem;
                    padding: 0 10px;
                }

                input {
                    border: none;
                    outline: none;
                    font-size: 18rem;
                    color: #666666;
                    .w(262);
                }

                .tree {
                    margin-top: 10rem;
                    height: 750 / 1080 * 100vh;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 0 !important;
                    }

                    /deep/ .el-scrollbar__wrap {
                        overflow-x: hidden;
                        height: calc(100% - 10px);
                    }

                    .el-tree {
                        padding-right: 24rem;
                    }
                }
            }
        }
    }

    .power-data-item {
        display: flex;
        justify-content: space-between;
        position: relative;
        width: 100%;

        .power-data-item1 {
            position: absolute;
            right: 0;
        }

        .power-data-item-label {
            font-size: 18rem;
            font-weight: 400;
            color: #666666;
            width: 80%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
        }

        .power-data-item-label.checked {
            font-weight: bold;
            color: #0d94ff;
        }

        .power-data-item-open {
            color: #68d86a;
            position: absolute;
            right: 0;
        }

        .power-data-item-close {
            position: absolute;
            right: 0;
            color: #fd4238;
        }
    }

    .no-found-data-warpper {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
    }

    //弹出框样式
    .area_popper {
        background-color: #3d4451 !important;
        border-radius: 6px !important;
        opacity: 0.9 !important;
        font-size: 12px !important;
        color: #ffffff !important;
        padding: 0 !important;
        transform: translateY(12px);
    }

    .showText {
        margin: 8px;
    }

    &::-webkit-scrollbar {
        width: 0 !important;
    }

    /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
        height: calc(100% - 10px);
    }

    .el-tree {
        padding-right: 33rem;
    }
</style>